import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import React, { Component, useEffect, useState } from "react";
import PageContent from "@my-dld/components/PageContent";
import Strings from "@my-dld/assets/strings";
import PageTitle from "@my-dld/components/PageTitle";
import { MyRequestsBCItem } from "@my-dld/contexts/PageContext";
import * as RVApi from "../../api/api";
import { convertReasonIdToLookup, feeDetails, ReportType, validateResponseX } from "../../api/api";
import { hideLoading, showErrorMessage, showLoading, showMessage } from "@my-dld/utils/UIUtils";
import { AuditedRVRequest, RVFeeItem, RVPropView } from "../../api/entities";
import { getRVReqArea, getRVReqDate, getRVReqPropertyType, getRVReqPropertyTypeID, getRVReqStatus } from "./Requests/RVRequests";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";
import { CurrencyUtil, LocaleUtil, StringUtil } from "@eres/core";
import { openBinaryAsDocument } from "@my-dld/utils/Utils";
import RVPropertyTable from "./RVPropertyTable";
import { MetricSystem } from "@my-dld/utils/UnitUtils";
import { Property, RvPropertyToProperty } from "../../api/Property";
import ListDataView from "../../../components/DataView/ListDataView";
import PayForContract from "@eres/ejari-web/component/Contract/PayForContract";
import RVPaymentSuccess from "./RVPaymentSuccess";
import { JQModal } from "@my-dld/components/Popup/Utils";

interface Props extends RoutedViewProps<{ reqNo: string }> {

}

interface State {
	PaymentReferenceNumber?: string;
	details?: AuditedRVRequest;
	properties?: Property[];
	items?: RVFeeItem[];
}

class RVRequestDetails extends Component<Props, State> {
	pay = React.createRef<PayForContract>();

	constructor( props: Props ) {
		super( props );
		this.state = {};
	}

	componentDidMount() {
		this.loadRVRequestDetails();
	}

	render() {
		const { details, properties, items, PaymentReferenceNumber } = this.state;
		const isRejected = ( details && details.AuditStatusId === 3 );
		return <PageContent
			title={ Strings.rental_evaluation_details }
			hideQLinks={ true }>
			<PageTitle title={ Strings.rental_evaluation_details } paths={ [ MyRequestsBCItem ] }/>
			{ details && <>
				<RenderRequestDetails details={ details }/>
				<RenderProperties details={ details }/>
				{
					properties && <RVPropertyTable
						key={ "-lnd" } type={ getRVReqPropertyTypeID( details ) }
						properties={ properties } unit={ MetricSystem } onSelect={ () => {
					} } view_type={ RVPropView.RV_REQ_Properties }/>
				}
				<RenderValuationReason details={ details }/>
				{ isRejected && <RenderRejectionReason details={ details }/> }
				{ !isRejected && <RenderFeeDetails details={ details }/> }
				{
					items && items.length > 0 && <ListDataView
						items={ items }
						renderListHeader={ () => {
							return <RenderHeader/>;
						} }
						renderListItem={ ( item: any, index: number ) => {
							return <RenderListItem
								key={ "" + index }
								item={ item } ix={ index }/>;
						} }/>
				}
				<div className="row">
					<div className="col-md-12">
						<div className="form-group">
							<button
								className="btn btn_1 btn_style1" type="submit"
								onClick={ this.onDownloadReqReport }>{ Strings.download_request_report }</button>
							{ !isRejected && ( details.RequestStatusId === 4 || details.RequestStatusId === 3 ) &&
								<button
									className="btn btn_1 btn_style1 ms-2 me-2" type="submit"
									onClick={ this.onDownloadReceipt }>{ Strings.download_receipt }</button> }
							{ !isRejected && details.RequestStatusId === 4 &&
								<button
									className="btn btn_1 btn_style1 me-2" type="submit"
									onClick={ this.onDownloadCertificate }>{ Strings.download_eval_certificate }</button> }
							{ details.RequestStatusId === 2 &&
								<button
									className="btn btn_1 btn_style1 me-2" type="submit"
									onClick={ this.onPay }>{ Strings.pay }</button> }
						</div>
					</div>
				</div>
			</> }
			{
				details && details!.RequestNumber &&
				<PayForContract contractNumber={ details.RequestNumber } prefixUrl={ "&rct=4" } ref={ this.pay }/>
			}
			{
				PaymentReferenceNumber && <RVPaymentSuccess
					payRef={ PaymentReferenceNumber }
					onDismiss={ this.onSuccessDismiss } onDownloadReceipt={ this.onDownloadReceipt }/>
			}
		</PageContent>;
	}

	private onSuccessDismiss = () => {
		JQModal( "RVPaySuccessPopup" ).hide();
		this.setState( { PaymentReferenceNumber: undefined }, this.loadRVRequestDetails );
	};

	private loadRVRequestDetails() {
		showLoading();
		const reqNo = this.props.match.params.reqNo;
		RVApi.getRVRequestDetails( reqNo ).then( RVApi.validateResponseX )
		.then( ( response: AuditedRVRequest ) => {
			let b: Property[] = [];
			if ( response && response.Properties ) {
				response.Properties.map( value => {
					b.push( RvPropertyToProperty( value ) );
				} );
			}
			this.setState( {
				details: response,
				properties: b,
			}, () => {
				feeDetails( response.RequestId + "" )
				.then( validateResponseX )
				.then( value => {
					hideLoading();
					this.setState( {
						items: value,
					} );
				} ).catch( e => {
					hideLoading();
					showErrorMessage( e.toString() );
				} );
			} );
		} ).catch( e => {
			hideLoading();
			showErrorMessage( e );
		} );
	}

	private onDownloadReqReport = () => {
		this.downloadOpenReport( "GetRequestReport", "RequestReport" );
	};

	private onDownloadReceipt = () => {
		this.downloadOpenReport( "GetPaymentReceiptReport", "ReceiptReport" );
	};

	private onDownloadCertificate = () => {
		this.downloadOpenReport( "GetEvaluationCertificateReport", "CertificateReport" );
	};

	private onPay = () => {
		this.pay.current?.initPayment( ( isSuccess, data ) => {
			if ( isSuccess ) {
				console.log( data );
				if ( data == undefined || data.refNumber == undefined || StringUtil.isEmptyStringOrNull( data.refNumber ) ) {
					let message = Strings.payment_failed;
					if ( data && data.message != undefined ) message = message + "\n" + data.message;
					showMessage( message );
				} else {
					this.setState( { PaymentReferenceNumber: data.refNumber }, () => {
						JQModal( "RVPaySuccessPopup" ).show();
					} );
				}
			}
		} );
	};

	private downloadOpenReport( reportType: ReportType, title: string ) {
		showLoading();
		const { details } = this.state;
		RVApi.downloadRVReport( details!.RequestNumber!, reportType ).then( validateResponseX ).then( pdfData => {
			openBinaryAsDocument( pdfData, title, "application/pdf" );
			hideLoading();
		} ).catch( e => {
			hideLoading();
			showErrorMessage( e );
		} );
	}
}

function RenderRequestDetails( props: { details: AuditedRVRequest } ) {
	const { details } = props;
	return <div id="RVSComplaintCard1">
		<div className="section-title">
			<h5>{ Strings.request_details }</h5>
		</div>
		<div className="flex-grid">
			<div>
				<span>{ Strings.request_number }</span>
				<span>{ details.RequestNumber }</span>
			</div>
			<div>
				<span>{ Strings.request_date }</span>
				<span>{ getRVReqDate( details ) }</span>
			</div>
			<div>
				<span>{ Strings.status }</span>
				<span>{ getRVReqStatus( details ) }</span>
			</div>
		</div>
	</div>;
}

function RenderProperties( props: { details: AuditedRVRequest } ) {
	const { details } = props;
	return <div id="RVSComplaintCard1">
		<div className="section-title">
			<h5>{ Strings.properties }</h5>
		</div>
		<div className="flex-grid">
			<div>
				<span>{ Strings.total_properties }</span>
				<span>{ details.Properties.length }</span>
			</div>
			<div>
				<span>{ Strings.property_type }</span>
				<span>{ getRVReqPropertyType( details ) }</span>
			</div>
			<div>
				<span>{ Strings.area }</span>
				<span>{ getRVReqArea( details ) }</span>
			</div>
		</div>
	</div>;
}

function RenderValuationReason( props: { details: AuditedRVRequest } ) {
	const { details } = props;
	return <div id="RVSComplaintCard1">
		<div className="section-title">
			<h5>{ Strings.reason_for_valuation }</h5>
		</div>
		<div className="flex-grid">
			<EvalReason id={ details.RequestReasonId } details={ details }/>
			{ !isEmptyStringOrNull( details.RequestDescription ) &&
				<div>
					<span>{ Strings.comments }</span>
					<span>{ details.RequestDescription }</span>
				</div> }
		</div>
	</div>;
}

function EvalReason( props: { id: number, details: AuditedRVRequest } ) {
	const { id, details } = props;
	const [ reason, setReason ] = useState( "" );
	useEffect( () => {
		const r = LocaleUtil.getLocalValue( { en: details.RequestReasonNameEn, ar: details.RequestReasonNameAr } );
		if ( isEmptyStringOrNull( r ) ) {
			convertReasonIdToLookup( id ).then( value => {
				setReason( LocaleUtil.getLocalValue( value ) );
			} ).catch( () => {
				setReason( "" );
			} );
		} else {
			setReason( r );
		}
	}, [ id ] );
	return <div>
		<span>{ Strings.reason_for_valuation }</span>
		<span>{ reason }</span>
	</div>;
}

function RenderRejectionReason( props: { details: AuditedRVRequest } ) {
	const { details } = props;
	return <div id="RVSComplaintCard1">
		<div className="section-title mb-3">
			<h5>{ Strings.rejection_reason }</h5>
		</div>
		<div className="flex-grid">
			<div>
				<span>{ Strings.rejection_reason }</span>
				<span>{ LocaleUtil.getLocalValue( {
					en: details.AuditRejectionReasonNameEn,
					ar: details.AuditRejectionReasonNameAr,
				} ) }</span>
			</div>
			{ !isEmptyStringOrNull( details.AuditorRemarks ) &&
				<div>
					<span>{ Strings.comments }</span>
					<span>{ details.AuditorRemarks }</span>
				</div> }
		</div>
	</div>;
}

function RenderFeeDetails( props: { details: AuditedRVRequest } ) {
	const { details } = props;
	if ( details.TotalAmount == undefined || isEmptyStringOrNull( details.TotalAmount + "" ) )
		return null;
	const amount = CurrencyUtil.toFormattedCurrency( details.TotalAmount ) + " " + Strings.aed;
	return <div id="RVSComplaintCard1">
		<div className="section-title">
			<h5>{ Strings.fee_details }</h5>
		</div>
		<div className="flex-grid">
			<div>
				<span>{ Strings.amount }</span>
				<span>{ amount }</span>
			</div>
		</div>
	</div>;
}

function RenderHeader() {
	return <tr>
		<th>{ Strings.type_of_valuation }</th>
		<th>{ Strings.fees + " (" + Strings.in_aed + ")" }</th>
	</tr>;
}

function RenderListItem( props: { item: RVFeeItem, ix: number } ) {
	const { item, ix } = props;
	return <tr role={ "row" } className={ ix % 2 === 0 ? "odd" : "even" } key={ "fee_" + ix }>
		<td>{ LocaleUtil.getLocalValue( { en: item.FeeNameEn, ar: item.FeeNameAr } ) }</td>
		<td>{ CurrencyUtil.toFormattedCurrency( item.Amount ) }</td>
	</tr>;
}

export default RVRequestDetails;
